var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-panel-area-header"},[_c('h4',[_vm._v("\n\t\t"+_vm._s(_vm.header)+"\n\t\t\t"),(_vm.plusMinus)?_c('div',[_vm._v(" "+_vm._s(_vm.open ? '-' : '+')+" ")]):_c('img',{staticClass:"caret",attrs:{"src":_vm.open ? require('@/assets/svg/chevronUp.svg') : require('@/assets/svg/chevronDown.svg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }